<template>
  <div>
    <zj-layout-container v-loading="loading"
      :element-loading-text="loadingText">
      <zj-layout-header>
        <div class="listtitle">安检记录</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="安检时间">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 60rem"
              unlink-panels
              value-format="yyyy-MM-dd"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="peopleNum"
                label="安检人数"
              ></el-table-column>
              <el-table-column
                prop="noIdCard"
                label="未带身份证数"
              ></el-table-column>
              <el-table-column prop="pack" label="包裹数"></el-table-column>
              <el-table-column
                prop="cigaretteLighter"
                label="打火机数"
              ></el-table-column>
              <el-table-column prop="uav" label="无人机数"></el-table-column>
              <el-table-column
                prop="stabilityMaintenanceEvent"
                label="维稳事件数"
              ></el-table-column>
              <el-table-column
                prop="createdate"
                label="上报时间"
              ></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import { findPage } from "@/request/securityApi";
export default {
  name: "SecuritySituationRecordList",
  controller: "UI",
  action: "SecuritySituationRecordList",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      date: [new Date(), new Date()],
      loading: false,
      loadingText: "加载中...",
    };
  },
  created: function() {},
  mounted: function() {
    this.search();
    this.logInfo.ActionName = "安检记录查询";
    this.logInfo.LogMessage = "安检记录查询";
    this.logInfo.ModuleName = "安检记录";
    this.logInfo.PageName = "安检记录列表";
    this.addOperationLog();
  },
  methods: {
    search() {
      this.loading = true;
      let params = {
        page: this.currentPage,
        size: this.pageSize,
        startDate: this.date[0],
        endDate: this.date[1],
      };
      findPage(params)
        .then((res) => {
          this.loading = false;
          if (res.code == 0) {
            this.tableData = res.data;
            this.total = res.count;
          }
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/securitySituation/ui/SecuritySituationRecordInfo",
        query: { InfoId: row.id, type: "query" },
      });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.date = [new Date(), new Date()];
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
};
</script>
